const imag = (abs: number, arg: number): number => abs * Math.sin(arg);

export default imag;
